/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type SettleFeesArgs = {
  minBaseToQuoteOut: bigint;
  minQuoteToBaseOut: bigint;
};

export type SettleFeesArgsArgs = {
  minBaseToQuoteOut: number | bigint;
  minQuoteToBaseOut: number | bigint;
};

export function getSettleFeesArgsEncoder(): FixedSizeEncoder<SettleFeesArgsArgs> {
  return getStructEncoder([
    ['minBaseToQuoteOut', getU64Encoder()],
    ['minQuoteToBaseOut', getU64Encoder()],
  ]);
}

export function getSettleFeesArgsDecoder(): FixedSizeDecoder<SettleFeesArgs> {
  return getStructDecoder([
    ['minBaseToQuoteOut', getU64Decoder()],
    ['minQuoteToBaseOut', getU64Decoder()],
  ]);
}

export function getSettleFeesArgsCodec(): FixedSizeCodec<
  SettleFeesArgsArgs,
  SettleFeesArgs
> {
  return combineCodec(getSettleFeesArgsEncoder(), getSettleFeesArgsDecoder());
}
